import { ConfigurationOverride } from 'baseui/helpers/overrides';
import { TrashSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import { IconButton } from 'components/elements/buttons';
import * as React from 'react';

interface Props {
  disabled?: boolean;
  onClick?: () => void;
  rootStyle?: ConfigurationOverride;
}

export default function DeleteIconButton(props: Props) {
  return (
    <IconButton
      onClick={() => {
        !props.disabled && props.onClick?.();
      }}
      buttonType="tertiary"
      overrides={{
        Root: {
          style: {
            height: '100%',
            ...props.rootStyle,
            ':hover': {
              backgroundColor: stylesColors.redLightest,
              borderColor: stylesColors.redLightest,
            },
            ':active': {
              backgroundColor: stylesColors.redLighter,
              borderColor: stylesColors.redLightest,
            },
            ':focus': {
              backgroundColor: stylesColors.redLighter,
              borderColor: stylesColors.redLightest,
            },
          },
        },
      }}
    >
      <TrashSVG color={stylesColors.redDefault} />
    </IconButton>
  );
}
